<script>
  import ItemResponse from "./ItemResponse.svelte";
  export let inputFocusAction,
    inputBlurAction,
    updateLayer,
    currLayer,
    currLayerPrev;
</script>

<!-- point -->
<div class="dupo-menu-pane mb-2">
  <div class="dupo-menu-pane-row">
    <h3 class="h-sub">Mark details</h3>
  </div>
</div>
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="text"
    token="shape-feature"
    title="Shape Feature"
    value={currLayer.mark.feature || ""}
    {inputFocusAction}
    {inputBlurAction}
    changeAction={(event) => {
      updateLayer(event, "mark.feature", currLayerPrev);
    }}
  />
</div>
